import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// ANT DESIGN
import { Row, Card, Select, Form, Col, Divider, Spin, DatePicker } from "antd";

//OTHER IMPORTS
import dayjs from "dayjs";

// PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { labelConfig, apiConfig, staticConfig } from "../../group.config";
import CustomButton from "../../../../components/custom/CustomButton";

const CloseGroup = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [closureReasonsData, setClosureReasonsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dateFormat = "DD-MM-YYYY";

  useEffect(() => {
    getTemplate();
    defaultDate();
  }, []);

  function onCancel() {
    navigate("/detail-group", { state: state });
  }

  const defaultDate = () => {
    useForm.setFieldsValue({
      closureDate: dayjs(),
    });
  };

  function getTemplate() {
    const params = {
      command: "close",
    };
    const url = `${apiConfig.Groups}/template`;
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempClosureReasons = [];

        objDetail?.closureReasons?.forEach((element) => {
          tempClosureReasons.push({
            value: element.id,
            label: element.name,
          });
        });

        setClosureReasonsData(tempClosureReasons);
        setIsLoading(false);
      }
    });
  }

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  const onSubmit = (formValues) => {
    formValues.closureDate = formValues.closureDate
      ? BOM.DateTime(formValues.closureDate, "only-date")
      : formValues.closureDate;

    const url = `${apiConfig.Groups}/${state.id}`;
    const params = {
      command: "close",
    };

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.closeCustomerGroupMsg);
        navigate("/detail-group", {
          state: { ...state },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.closeGroup}
        pageItems={staticConfig.closeGroupBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
            initialValues={{
              closureReasons: false,
              postInterestValidationOnClosure: true,
            }}
          >
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.closureDate}
                  name="closureDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.closureDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledAfterCurrentDate}
                    style={{ width: "100%", height: 35 }}
                    format={dateFormat}
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="closureReasonId"
                  label={labelConfig.closureReasons}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.closureDate),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.closureReasons,
                      "select"
                    )}
                    options={closureReasonsData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CLOSE_GROUP") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default CloseGroup;
